/* LegBilligt — KUNDESERVICE, emneraekken og svarene.
   1. Raekken af emnekort swipes med finger og pegefelt (scroll-snap i CSS).
      Pilene giver mus praecis det samme skridt. De taendes foerst her, saa
      de aldrig staar og lyver hvis JS fejler.
   2. Kun ét emne vises ad gangen. Uden JS staar alle grupper — siden er
      lang, men hel. Med JS bliver den kort, og kortet er valget.
   Ingen MutationObserver. */
(function(){
  var raekke = document.getElementById('lbk-raekke');
  var baelte = document.getElementById('lbk-emner');
  var spalte = document.getElementById('lbk-spalte');
  if(!baelte || !spalte) return;
  var kort = baelte.querySelectorAll('.lbk-e');
  var grupper = spalte.querySelectorAll('.lbk-gr');
  if(!kort.length || !grupper.length) return;

  /* ---------- ét emne ad gangen ---------- */
  function vis(nr, rul){
    var fandt = false, i, j;
    for(i = 0; i < grupper.length; i++){
      if(grupper[i].getAttribute('data-g') === String(nr)) fandt = true;
    }
    if(!fandt) return false;
    for(i = 0; i < grupper.length; i++){
      grupper[i].hidden = grupper[i].getAttribute('data-g') !== String(nr);
    }
    for(j = 0; j < kort.length; j++){
      var valgt = kort[j].getAttribute('data-g') === String(nr);
      if(valgt){ kort[j].classList.add('er-valgt'); kort[j].setAttribute('aria-current','true'); }
      else { kort[j].classList.remove('er-valgt'); kort[j].removeAttribute('aria-current'); }
    }
    if(rul){
      var maal = document.getElementById('lbk-svar');
      if(maal && maal.scrollIntoView) maal.scrollIntoView({behavior:'smooth', block:'start'});
    }
    return true;
  }

  for(var k = 0; k < kort.length; k++){
    kort[k].addEventListener('click', function(e){
      var nr = this.getAttribute('data-g');
      if(vis(nr, true)) e.preventDefault();
    });
  }

  /* Kommer man ind paa #emne-3 fra et link, aabner vi den gruppe. */
  var start = null;
  var m = (window.location.hash || '').match(/^#emne-(\d+)$/);
  if(m) start = m[1];
  if(!start || !vis(start, false)) vis(grupper[0].getAttribute('data-g'), false);

  /* ---------- pilene ---------- */
  if(raekke){
    var pv = raekke.querySelector('.lbk-pil--v');
    var ph = raekke.querySelector('.lbk-pil--h');
    var skridt = function(){
      return kort[0] ? kort[0].getBoundingClientRect().width + 20 : 300;
    };
    var opdater = function(){
      var maks = baelte.scrollWidth - baelte.clientWidth - 8;
      if(pv) pv.disabled = baelte.scrollLeft <= 8;
      if(ph) ph.disabled = maks <= 0 || baelte.scrollLeft >= maks;
    };

    /* CSS'ens "scroll-behavior:smooth" aflyser en programmeret rulning i
       flere browsere — pilene stod og gjorde ingenting. Derfor slaas den
       fra her, og vi ruller selv med requestAnimationFrame. Snappet
       pauses undervejs, ellers trakker det raekken tilbage midt i turen. */
    baelte.style.scrollBehavior = 'auto';
    var blid = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
               && !!window.requestAnimationFrame;
    var ruller = function(maal){
      var maks = baelte.scrollWidth - baelte.clientWidth;
      if(maal < 0) maal = 0;
      if(maal > maks) maal = maks;
      var tid = 340, faerdig = false;
      var slut = function(){
        if(faerdig) return;
        faerdig = true;
        baelte.scrollLeft = maal;
        baelte.style.scrollSnapType = '';
        opdater();
      };
      if(!blid){ slut(); return; }
      var fra = baelte.scrollLeft, forskel = maal - fra, t0 = null;
      baelte.style.scrollSnapType = 'none';
      /* Vagten: koerer billedloekken ikke (fanen er skjult, batterisparetilstand),
         lander raekken alligevel det rigtige sted i stedet for at staa stille. */
      var vagt = window.setTimeout(slut, tid + 300);
      var trin = function(ts){
        if(faerdig) return;
        if(t0 === null) t0 = ts;
        var p = (ts - t0) / tid;
        if(p > 1) p = 1;
        var e = 1 - Math.pow(1 - p, 3);
        baelte.scrollLeft = fra + forskel * e;
        if(p < 1){ window.requestAnimationFrame(trin); }
        else { window.clearTimeout(vagt); slut(); }
      };
      window.requestAnimationFrame(trin);
    };

    var pile = raekke.querySelectorAll('.lbk-pil');
    for(var p = 0; p < pile.length; p++){
      pile[p].addEventListener('click', function(){
        var ret = parseInt(this.getAttribute('data-ret'), 10) || 1;
        ruller(baelte.scrollLeft + skridt() * ret);
      });
    }
    baelte.addEventListener('scroll', opdater, {passive:true});
    window.addEventListener('resize', opdater);
    raekke.classList.add('klar');
    opdater();
  }
})();
